import { render, staticRenderFns } from "./AdminDataReportStatus.vue?vue&type=template&id=40c26fc2&scoped=true"
import script from "./AdminDataReportStatus.vue?vue&type=script&lang=js"
export * from "./AdminDataReportStatus.vue?vue&type=script&lang=js"
import style0 from "./AdminDataReportStatus.vue?vue&type=style&index=0&id=40c26fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c26fc2",
  null
  
)

export default component.exports